import { type Transaction } from 'dexie';
import { type Discount } from '../../models';
import { BOOLEAN_VALUE } from '../../types';

export const schemaV8 = {
    taxes: 'id, name, value, deleted, [id+deleted]',
    paymentMethods:
        'id, name, type, deleted, enabled, [id+deleted], [enabled+deleted]',
    staff: 'id, authUserId, role, deleted, registerPin, [registerPin+deleted], [id+deleted]',

    items: 'id, name, itemType, categoryId, measurementUnitId, isActive, [id+isActive], nameLower, *searchTokens',
    itemVariants:
        'id, name, sku, barcode, itemPriceType, itemId, deleted, [id+deleted], [itemId+deleted]',

    itemVariantCompositions:
        'id, variantId, deleted, [id+deleted], parentVariantId',

    categories: 'id, name, deleted, [id+deleted]',
    measurementUnits: 'id, name, deleted, [id+deleted]',

    discounts: 'id, hasRules, deleted, [id+deleted]',
};

export async function v8Upgrade(transaction: Transaction) {
    return transaction
        .table('discounts')
        .toCollection()
        .modify((discount: Discount) => {
            discount.hasRules = discount.rules?.length
                ? BOOLEAN_VALUE.TRUE
                : BOOLEAN_VALUE.FALSE;
        });
}
